import React, { FC, useCallback } from 'react';
import { ProductCardsContent } from '../ProductCardsContent';
import { buildRegistrationLink } from 'utils/offersTableConfigs/utils';
import { UnauthorizedProductCardsProps } from './types';
import { getDomainConfig, useFeatureFlag } from '@raisin/cp-utils';

const UnauthorizedProductCards: FC<UnauthorizedProductCardsProps> = (props) => {
  const { variation } = useFeatureFlag();
  const { dbs, locale } = props;
  const config = getDomainConfig(props?.locale);
  const shouldUseBankSlugFallback = variation?.('b2CShouldUseBankSlugFallback', false);

  const onLinkGenerate = useCallback(
    (productId: string) => {
      if (locale === 'en-GB') {
        return buildRegistrationLink(
          props.locale,
          'product_details',
          dbs[productId],
          null,
          shouldUseBankSlugFallback,
        );
      }
      return `${config?.registrationPath}?product=${productId}`;
    },
    [locale, dbs],
  );
  return <ProductCardsContent testId="Unauthorized" {...props} linkGenerator={onLinkGenerate} />;
};

export default UnauthorizedProductCards;
